import PageWrapper from "@/components/layout/page-wrapper";
import { Card } from "@/components/ui/card";
import { Link, Outlet, useLocation } from "react-router";
import { cn } from "@/lib/utils";

const ProactiveLayout = () => {
    const location = useLocation();
    return (
        <PageWrapper
            pageTitle={location.pathname.split("?")[0].includes("easy-setup") ? "Easy Proactive Chat Setup" : location.pathname.split("?")[0].includes("advance-setup") ? "Advanced Proactive Chat Setup" : "Proactive Chat List"}
            currentPage={location.pathname.split("?")[0].includes("easy-setup") ? "Easy Proactive Chat Setup" : location.pathname.split("?")[0].includes("advance-setup") ? "Advanced Proactive Chat Setup" : "Proactive Chat List"}
            previousPages={[{ title: "Proactive Chats", url: "/app/proactive-chats" }]}
        >
            <Card className="mb-4 border bg-gray-200 shadow-none">
                <div className="flex w-full  max-w-[calc(100vw-70px)] gap-3 overflow-x-auto p-1  md:overflow-x-hidden">
                    <Link
                        to="proactive-chat-list"
                        className={cn(
                            location.pathname.split("?")[0].includes("proactive-chat-list") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Proactive Chat List
                    </Link>
                    <Link
                        to="easy-setup"
                        className={cn(
                            location.pathname.split("?")[0].includes("easy-setup") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Easy Setup
                    </Link>
                    <Link
                        to="advance-setup"
                        className={cn(
                            location.pathname.split("?")[0].includes("advance-setup") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Advance Setup
                    </Link>
                </div>
            </Card>

            <Outlet />
        </PageWrapper>
    );
};

export default ProactiveLayout;
